<template>
  <div class="q-pa-lg">
    <div class="row justify-between items-start">
      <h1>Проекты <span class="data-rows-number">{{ projectsTotal }}</span></h1>
      <q-btn
        v-if="isCreationAllowed"
        @click="newProject = true"
        color="primary"
        class="q-mt-sm"
      >
        Новый проект
      </q-btn>
      <project-create v-model="newProject"/>
    </div>
    <projects-list/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ProjectsList from '@/ProjectsList';
  import ProjectCreate from '@/ProjectCreate';
  import {
    QBtn
  } from 'quasar';

  export default {
    name: 'Projects',
    components: {
      QBtn,
      ProjectCreate,
      ProjectsList
    },
    data () {
      return {
        newProject: false
      };
    },
    computed: {
      isCreationAllowed() {
        return this.$auth.check('root') || this.$auth.check('manager')
      },
      ...mapGetters({
        projectsTotal: 'projectsList/total'
      })
    },
  };
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/ProjectsView.vue